module.exports = __webpack_public_path__ + "static/img/FreeBuds1.682fb292.jpg";